import { render, staticRenderFns } from "./addClass.vue?vue&type=template&id=d5a7d77c&scoped=true&"
import script from "./addClass.vue?vue&type=script&lang=js&"
export * from "./addClass.vue?vue&type=script&lang=js&"
import style0 from "./addClass.vue?vue&type=style&index=0&id=d5a7d77c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a7d77c",
  null
  
)

export default component.exports